export default __webpack_public_path__ + "static/media/CardCompressionAttack.81a773ee.svg";